import React from 'react';
import { PauseIcon, PlayIcon, Volume2Icon } from 'lucide-react';
import { BottomSheet } from './BottomSheet';
import { AMBIENT_SOUNDS } from '../data/presets';
import { useAmbient } from '../contexts/AmbientContext';
interface SoundSheetProps {
  open: boolean;
  onClose: () => void;
}
export function SoundSheet({
  open,
  onClose
}: SoundSheetProps) {
  const {
    sound,
    volume,
    playing,
    error,
    select,
    toggle,
    changeVolume
  } = useAmbient();
  return <BottomSheet open={open} title="Focus sounds" onClose={onClose} data-id="element-59" data-mp="2oy5a0ejs57uh">
      <div className="flex flex-col gap-2" data-id="element-60" data-mp="2jzu3odsp1fh0">
        {AMBIENT_SOUNDS.map(({
        id,
        label,
        description
      }) => {
        const active = sound === id;
        return <button key={id} type="button" aria-pressed={active} onClick={() => select(id)} className={`flex min-h-[56px] items-center justify-between rounded-xl border px-4 text-left transition-colors duration-150 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-coral ${active ? 'border-coral bg-coral/10' : 'border-line hover:border-muted'}`} data-id="element-61" data-mp="2tx8fu17l3i3i">
              <span data-id="element-62" data-mp="dovvh7sw8px2">
                <span className="block text-sm font-medium text-ink" data-id="element-63" data-mp="dqfbcxan0yyb">{label}</span>
                <span className="block text-xs text-muted" data-id="element-64" data-mp="hqzcebyc0mpq">{description}</span>
              </span>
              {active && playing && <span className="text-xs font-medium text-coral" data-id="element-65" data-mp="3h7p9flpl3grr">Playing</span>}
            </button>;
      })}
      </div>

      <div className="mt-4 flex items-center gap-3" data-id="element-66" data-mp="3q614q11eb2qj">
        <button type="button" onClick={toggle} aria-label={playing ? 'Pause ambient sound' : 'Play ambient sound'} className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-coral text-white transition-colors duration-150 hover:bg-coral-strong focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-coral" data-id="element-67" data-mp="3q8nco1s77k9a">
          {playing ? <PauseIcon size={18} strokeWidth={1.75} data-id="element-68" data-mp="32h7usd1cl850" /> : <PlayIcon size={18} strokeWidth={1.75} data-id="element-69" data-mp="32g6arj2ctbb5" />}
        </button>
        <Volume2Icon size={18} strokeWidth={1.5} className="shrink-0 text-muted" aria-hidden="true" data-id="element-70" data-mp="3gh8v9rdpadjy" />
        <input type="range" min={0} max={1} step={0.01} value={volume} onChange={e => changeVolume(Number(e.target.value))} aria-label="Ambient sound volume" className="h-11 w-full accent-coral focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-coral" data-id="element-71" data-mp="3bhcrnt8x0o4x" />
      </div>

      <p className="mt-3 text-xs leading-relaxed text-muted" role={error ? 'alert' : undefined} data-id="element-72" data-mp="2squzpqvwpwkm">
        {error ?? 'Sound pauses with your session and resumes when you continue.'}
      </p>
    </BottomSheet>;
}